import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const features = [
  { icon: 'ri-git-branch-line', title: 'Araştırma Burslarına Hizmet Edin', desc: 'Her araştırma bursu için farklı kiracılar oluşturarak kaynakları, faturalamayı, güvenliği ve uyumluluk gereksinimlerini ayrı ayrı yönetin.' },
  { icon: 'ri-money-dollar-circle-line', title: 'Sermaye Harcamalarını Azaltın', desc: 'Daha fazla x86 emtia sunucusu ekleyerek hesaplama, bellek ve depolama kaynaklarını bağımsız biçimde ölçeklendirin.' },
  { icon: 'ri-shield-check-line', title: 'Uyumluluğu Artırın', desc: 'HIPAA, CUI, FISMA ve daha fazlası gibi standartlarla uyumlu güvenli enklav ortamlarını dakikalar içinde oluşturun.' },
  { icon: 'ri-robot-line', title: 'BT Ekibinin Yükünü Hafifletin', desc: 'VergeIO, donanım izleme, yama ve BT yönetiminin sıkıcı işlerini yönetmek için makine öğrenimi ve AI tekniklerini kullanır.' },
  { icon: 'ri-refresh-line', title: 'Felaket Kurtarma', desc: 'Anlık görüntü ve çok siteli senkronizasyon, genel IP adresleri ve DR yedeklemesi dahil tam bir sanal veri merkezinin yük devrine olanak tanır.' },
  { icon: 'ri-database-2-line', title: 'Daha Fazla Depolama', desc: 'Global tekilleştirme, tüm VergeIO kurulumlarının en az miktarda donanım kullanmasını ve en yüksek dayanıklılık derecesini sağlamasını garantiler.' },
];

const srcJsonLd = { '@context': 'https://schema.org', '@type': 'SoftwareApplication', name: 'VergeOS Güvenli Araştırma Bilişimi', applicationCategory: 'BusinessApplication', operatingSystem: 'Any', description: 'VergeOS ile araştırma kurumları için izole, güvenli hesaplama ortamları. HIPAA/FERPA uyumlu multi-tenant araştırma altyapısı.', url: `${SITE_URL}/secure-research-computing` };

export default function SecureResearchComputingPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead title="Güvenli Araştırma Bilişimi | HPC | VergeOS" description="VergeOS ile araştırma kurumları için izole, güvenli hesaplama ortamları. HIPAA/FERPA uyumlu, multi-tenant araştırma altyapısı ve GPU iş yükleri." keywords="güvenli araştırma bilişimi, HPC, araştırma altyapısı, VergeOS, HIPAA, FERPA, GPU" canonicalPath="/secure-research-computing" jsonLd={srcJsonLd} />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">BT Girişimleri</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              <span className="text-[#e8600a]">Güvenli Araştırma</span> Bilişimi
            </h1>
            <p className="text-xl text-gray-300 mb-3 font-medium">Araştırma ve uzaktan öğrenim için güvenli</p>
          </div>
        </section>

        {/* Benefits Intro */}
        <section className="py-14 bg-gray-50 border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-2xl font-bold text-[#1e293b] mb-4 text-center">Faydalar</h2>
            <p className="text-gray-600 text-center mb-6 text-sm">Karmaşık araştırma veya uzaktan öğrenim ortamları için çevikliği kaybetmeden yüksek düzeyde uyumluluk ve standardizasyonu koruyun.</p>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              {['Araştırmacılar için güvenli ortam sağlayın', 'Altyapı için daha az bekleme süresi', 'Dakikalar içinde uyumlu sanal veri merkezleri sunun', 'Araştırma projesi boyunca kaynakları kolayca genişletin', 'Kendi mülkünüzdeki mevcut donanımı kullanın'].map(item => (
                <div key={item} className="bg-white rounded-lg p-3 border border-gray-100 text-center">
                  <i className="ri-check-double-line text-[#e8600a] text-lg mb-2 block"></i>
                  <p className="text-xs text-gray-600">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Streamline IT */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[#1e293b] mb-4">BT Operasyonlarını Düzenleyin</h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-sm">Son derece çevik, ölçeklenebilir ve güvenli araştırma bilişimi sağlamak için iç içe güvenli enklavları kullanın.</p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map(f => (
                <div key={f.title} className="bg-[#f8fafc] rounded-lg border border-gray-100 p-6">
                  <span className="w-10 h-10 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] mb-4"><i className={`${f.icon} text-xl`}></i></span>
                  <h3 className="font-semibold text-[#1e293b] mb-2 text-sm">{f.title}</h3>
                  <p className="text-xs text-gray-600 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

      </main>
      <FooterSection />
    </div>
  );
}
